/* Timbrica — /solar-system. Солнечная система в 3D на настоящих положениях.
 *
 * ПОЧЕМУ ЭТОТ ТУЛ
 * ---------------
 * «Солнечная система» — 228 909 показов/мес, «планеты по порядку» — 23 472,
 * «парад планет» — 60 743. В выдаче по всем трём НЕТ ИНТЕРАКТИВА: Википедия,
 * Рувики, Фоксфорд, Циклопедия, БРЭ, РИА. Люди спрашивают картинку и получают
 * текст. При этом наш /earth-globe стоит первым ВЫШЕ Google Earth — формат наш.
 *
 * ЧЕМ ОТЛИЧАЕМСЯ
 *   1. ЧЕСТНЫЙ МАСШТАБ. Настоящую Солнечную систему нарисовать нельзя: если
 *      Земля — пиксель, Нептун за 4 000 пикселей, а Солнце влезет только в
 *      полкадра. Все рисуют «красиво» и молчат об этом. У нас переключатель
 *      с прямым текстом, что именно искажено в каждом режиме.
 *   2. ЖИВЫЕ ПОЛОЖЕНИЯ, а не декоративное вращение: планеты стоят там, где они
 *      сейчас, по тем же эфемеридам, что и остальные астро-тулы.
 *   3. «СКОЛЬКО ЛЕТЕТЬ ДО МАРСА» (322 921 показов у одной этой фразы) —
 *      отвечаем настоящим ТЕКУЩИМ расстоянием, а не средним из справочника:
 *      оно меняется в 7 раз за синодический период.
 *   4. ПАРАД ПЛАНЕТ — считаем разброс долгот и находим ближайшие сближения,
 *      вместо пересказа новостей.
 */
(function () {
  'use strict';

  var C = window.SOLAR_CFG || {};
  var T = C.t || {};
  var tr = function (k) { return T[k] != null ? T[k] : k; };
  var $ = function (id) { return document.getElementById(id); };
  var ae = function (ev, p) { try { window.__ae && window.__ae(ev, p || {}); } catch (e) {} };
  var stage = function (n) { try { window.__stage && window.__stage(n); } catch (e) {} };

  var A = window.Astronomy;
  if (!A) {
    var host0 = $('ssScene');
    if (host0) host0.innerHTML = '<div class="ss-err">' + tr('engine_failed') + '</div>';
    ae('tool_error', { slug: 'solar-system', reason: 'astro_core_missing' });
    return;
  }

  var DEG = Math.PI / 180;
  var AU_KM = 149597870.7;
  var C_KM_S = 299792.458;

  // Справочные величины тел. Радиус в км, гравитация в g, сутки в земных часах,
  // год в земных сутках. Это факты из справочника, а не расчёт.
  var BODIES = [
    { key: 'Mercury', color: 0x9c8f83, radiusKm: 2439.7, gravity: 0.378, dayH: 4222.6, yearD: 88.0, moons: 0, orbitAu: 0.387 },
    { key: 'Venus', color: 0xd8b48a, radiusKm: 6051.8, gravity: 0.907, dayH: 2802.0, yearD: 224.7, moons: 0, orbitAu: 0.723 },
    { key: 'Earth', color: 0x4d8fd6, radiusKm: 6371.0, gravity: 1.000, dayH: 24.0, yearD: 365.26, moons: 1, orbitAu: 1.000 },
    { key: 'Mars', color: 0xc1543a, radiusKm: 3389.5, gravity: 0.377, dayH: 24.7, yearD: 687.0, moons: 2, orbitAu: 1.524 },
    { key: 'Jupiter', color: 0xd8a878, radiusKm: 69911, gravity: 2.360, dayH: 9.9, yearD: 4331, moons: 95, orbitAu: 5.203 },
    { key: 'Saturn', color: 0xe0cd9a, radiusKm: 58232, gravity: 0.916, dayH: 10.7, yearD: 10747, moons: 146, orbitAu: 9.537 },
    { key: 'Uranus', color: 0x9fd8de, radiusKm: 25362, gravity: 0.889, dayH: 17.2, yearD: 30589, moons: 28, orbitAu: 19.191 },
    { key: 'Neptune', color: 0x5a7fd6, radiusKm: 24622, gravity: 1.120, dayH: 16.1, yearD: 59800, moons: 16, orbitAu: 30.069 }
  ];
  // Пять планет, видимых невооружённым глазом — именно их «парад» ищут люди.
  var NAKED_EYE = ['Mercury', 'Venus', 'Mars', 'Jupiter', 'Saturn'];

  var state = {
    when: new Date(),
    live: true,
    scale: 'readable',        // 'readable' — по порядку, 'true' — по расстоянию
    selected: 'Mars',         // «сколько лететь до Марса» — самый частый вопрос
    speedDays: 0              // сколько суток прибавлять за кадр при проигрывании
  };

  // ── Форматирование ──────────────────────────────────────────────────────────

  function fmt(x, d) {
    try { return Number(x).toLocaleString(C.locale, { minimumFractionDigits: d || 0, maximumFractionDigits: d || 0 }); }
    catch (e) { return Number(x).toFixed(d || 0); }
  }
  function fmtDate(d) {
    try { return d.toLocaleDateString(C.locale, { day: 'numeric', month: 'long', year: 'numeric' }); }
    catch (e) { return d.toISOString().slice(0, 10); }
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }
  function setText(id, v) { var el = $(id); if (el) el.textContent = v; }

  /** Человеческая длительность из часов: «24,7 ч», «7 мес», «2,1 года». */
  function humanDuration(hours) {
    var days = hours / 24;
    // ⚠️ До 3 суток держим ЧАСЫ. Иначе марсианские сутки (24,7 ч) округляются
    // до «1 сут» и исчезает ровно тот факт, ради которого сюда и заходят.
    if (days < 3) return fmt(hours, 1) + ' ' + tr('u_hours');
    if (days < 60) return fmt(days, 0) + ' ' + tr('u_days');
    var months = days / 30.44;
    if (months < 24) return fmt(months, 1) + ' ' + tr('u_months');
    return fmt(days / 365.25, 1) + ' ' + tr('u_years');
  }

  // ── Данные ──────────────────────────────────────────────────────────────────

  function helio(key, date) { return A.HelioVector(key, date); }

  function distanceAu(a, b) {
    return Math.hypot(a.x - b.x, a.y - b.y, a.z - b.z);
  }

  /** Всё о выбранной планете на текущий момент. */
  function bodyFacts(key, date) {
    var b = null;
    for (var i = 0; i < BODIES.length; i++) if (BODIES[i].key === key) b = BODIES[i];
    if (!b) return null;
    var p = helio(key, date), e = helio('Earth', date);
    var fromSun = Math.hypot(p.x, p.y, p.z);
    var fromEarth = key === 'Earth' ? 0 : distanceAu(p, e);
    var illum = null;
    try { illum = A.Illumination(key, date); } catch (x) { illum = null; }
    return {
      body: b,
      fromSunAu: fromSun,
      fromEarthAu: fromEarth,
      lightMin: fromEarth * AU_KM / C_KM_S / 60,
      magnitude: illum ? illum.mag : null,
      elongation: key === 'Earth' ? null : A.AngleFromSun(key, date)
    };
  }

  /**
   * Парад планет: ищем даты, когда пять видимых глазом планет собираются в
   * узкий сектор эклиптики. Разброс считаем как минимальную дугу, накрывающую
   * все пять долгот — «максимум минус минимум» врёт на стыке 0°/360°.
   */
  function paradeSpread(date) {
    var lons = NAKED_EYE.map(function (k) {
      var v = A.HelioVector(k, date);
      var ecl = A.Ecliptic(v);
      return ((ecl.elon % 360) + 360) % 360;
    }).sort(function (a, b) { return a - b; });

    var biggestGap = 0;
    for (var i = 0; i < lons.length; i++) {
      var next = lons[(i + 1) % lons.length];
      var gap = ((next - lons[i]) + 360) % 360;
      if (gap > biggestGap) biggestGap = gap;
    }
    return 360 - biggestGap;
  }

  /**
   * Ближайшие сближения — локальные минимумы разброса за следующие N лет.
   *
   * ⚠️ Порога «меньше 95°» здесь быть не должно. Строгого определения парада
   * планет не существует, а жёсткий порог даёт бесполезный ответ «сближений не
   * будет» — при том что минимумы есть всегда и людям нужны именно они.
   * Поэтому берём ВСЕ локальные минимумы и показываем самые тесные, а число
   * градусов пишем рядом, чтобы человек сам судил, тесно это или нет.
   */
  function findParades(fromDate, years) {
    var mins = [], step = 4 * 86400000;
    var end = fromDate.getTime() + years * 365.25 * 86400000;
    var prev = null, prevPrev = null, prevDate = null;
    for (var t = fromDate.getTime(); t <= end; t += step) {
      var d = new Date(t), s = paradeSpread(d);
      if (prevPrev != null && prev < prevPrev && prev <= s) mins.push({ date: prevDate, spread: prev });
      prevPrev = prev; prev = s; prevDate = d;
    }
    // Сортируем по тесноте, но показываем в хронологическом порядке — иначе
    // список читается как рейтинг, а не как календарь.
    return mins.sort(function (a, b) { return a.spread - b.spread; }).slice(0, 5)
      .sort(function (a, b) { return a.date - b.date; });
  }

  // ── Сцена ───────────────────────────────────────────────────────────────────

  var THREE = null, renderer = null, scene3 = null, camera = null, sceneReady = false;
  var meshes = {}, orbits = {}, sunMesh = null, raycaster = null, camAngle = { az: 0.6, el: 0.9, dist: 42 };

  function sceneHost() { return $('ssScene'); }

  function measure() {
    var host = sceneHost();
    var w = host.clientWidth || host.parentElement.clientWidth || 420;
    return { w: w, h: Math.round(w * 0.62) };
  }

  function initThree() {
    var host = sceneHost();
    if (!host) return Promise.resolve(false);
    // Список по приоритету: свой origin, потом зеркало. См. cdn_chain() и
    // public/js/asset-chain.js — раньше здесь читался только primary, и на
    // intl-локалях сцена целиком зависела от jsdelivr.
    var urls = (C.three && C.three.length) ? C.three : [];
    if (!urls.length) return Promise.resolve(false);
    var chain = window.__assetChain;
    var load = chain ? chain.importModule(urls, 'three') : import(urls[0]);
    return load.then(function (mod) {
      THREE = mod;
      var m = measure();
      try { renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, powerPreference: 'low-power', preserveDrawingBuffer: true }); }
      catch (e) { return false; }
      renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
      renderer.setSize(m.w, m.h);
      host.appendChild(renderer.domElement);
      renderer.domElement.setAttribute('aria-label', tr('canvas_aria'));

      scene3 = new THREE.Scene();
      camera = new THREE.PerspectiveCamera(45, m.w / m.h, 0.1, 5000);
      scene3.add(new THREE.AmbientLight(0xffffff, 0.55));
      var pl = new THREE.PointLight(0xfff2d0, 2.2, 0, 0);
      scene3.add(pl);

      sunMesh = new THREE.Mesh(new THREE.SphereGeometry(1, 32, 24),
        new THREE.MeshBasicMaterial({ color: 0xffd27a }));
      scene3.add(sunMesh);

      BODIES.forEach(function (b) {
        var mesh = new THREE.Mesh(new THREE.SphereGeometry(1, 28, 20),
          new THREE.MeshLambertMaterial({ color: b.color }));
        mesh.userData.key = b.key;
        scene3.add(mesh);
        meshes[b.key] = mesh;

        var geo = new THREE.BufferGeometry();
        geo.setAttribute('position', new THREE.BufferAttribute(new Float32Array(3 * 129), 3));
        var line = new THREE.LineLoop(geo, new THREE.LineBasicMaterial({ color: 0x3a4a63 }));
        scene3.add(line);
        orbits[b.key] = line;
      });

      raycaster = new THREE.Raycaster();
      bindScene(renderer.domElement);
      sceneReady = true;
      window.addEventListener('resize', onResize, { passive: true });
      return true;
    }).catch(function () { return false; });
  }

  function onResize() {
    if (!sceneReady) return;
    var m = measure();
    renderer.setSize(m.w, m.h);
    camera.aspect = m.w / m.h;
    camera.updateProjectionMatrix();
    render3();
  }

  function bindScene(el) {
    var dragging = false, last = null;
    function pt(e) { var t = e.touches ? e.touches[0] : e; return { x: t.clientX, y: t.clientY }; }
    el.addEventListener('mousedown', function (e) { dragging = true; last = pt(e); el.style.cursor = 'grabbing'; });
    window.addEventListener('mouseup', function () { dragging = false; el.style.cursor = 'grab'; });
    window.addEventListener('mousemove', function (e) {
      if (!dragging || !last) return;
      var p = pt(e);
      camAngle.az -= (p.x - last.x) * 0.006;
      camAngle.el = Math.max(0.06, Math.min(1.52, camAngle.el - (p.y - last.y) * 0.006));
      last = p; render3();
    });
    el.addEventListener('touchstart', function (e) { dragging = true; last = pt(e); }, { passive: true });
    el.addEventListener('touchmove', function (e) {
      if (!dragging || !last) return;
      var p = pt(e);
      camAngle.az -= (p.x - last.x) * 0.008;
      camAngle.el = Math.max(0.06, Math.min(1.52, camAngle.el - (p.y - last.y) * 0.008));
      last = p; render3();
      if (e.cancelable) e.preventDefault();
    }, { passive: false });
    el.addEventListener('touchend', function () { dragging = false; });
    el.addEventListener('wheel', function (e) {
      camAngle.dist = Math.max(6, Math.min(160, camAngle.dist * (1 + Math.sign(e.deltaY) * 0.12)));
      render3(); e.preventDefault();
    }, { passive: false });
    el.style.cursor = 'grab';

    // Клик по планете — выбор. Без него 3D остаётся картинкой, а не инструментом.
    el.addEventListener('click', function (e) {
      if (!sceneReady) return;
      var r = el.getBoundingClientRect();
      var mouse = new THREE.Vector2(((e.clientX - r.left) / r.width) * 2 - 1,
        -((e.clientY - r.top) / r.height) * 2 + 1);
      raycaster.setFromCamera(mouse, camera);
      var hits = raycaster.intersectObjects(Object.keys(meshes).map(function (k) { return meshes[k]; }));
      if (hits.length) { selectBody(hits[0].object.userData.key); ae('feature_use', { slug: 'solar-system', feature: 'pick_planet' }); }
    });
  }

  /**
   * Радиус орбиты на экране. Здесь и живёт «честный масштаб»:
   *   true     — расстояния настоящие (Нептун в 30 раз дальше Земли);
   *   readable — кубический корень, орбиты сжимаются к читаемым, и мы прямо
   *              пишем на странице, что расстояния искажены.
   */
  function orbitScale(au) {
    return state.scale === 'true' ? au * 1.15 : Math.pow(au, 0.42) * 6.2;
  }
  /** Размер шарика. В обоих режимах преувеличен — иначе планеты невидимы. */
  function bodyScale(radiusKm) {
    return Math.max(0.16, Math.pow(radiusKm / 6371, 0.42) * 0.42);
  }

  function render3() {
    if (!sceneReady) return;
    var date = state.when;

    sunMesh.scale.setScalar(state.scale === 'true' ? 0.6 : 1.0);

    BODIES.forEach(function (b) {
      var v = A.HelioVector(b.key, date);
      var ecl = A.Ecliptic(v);
      var r = Math.hypot(v.x, v.y, v.z);
      var lon = ecl.elon * DEG;
      var R = orbitScale(r);
      var mesh = meshes[b.key];
      mesh.position.set(Math.cos(lon) * R, 0, -Math.sin(lon) * R);
      mesh.scale.setScalar(bodyScale(b.radiusKm));
      mesh.material.emissive = new THREE.Color(state.selected === b.key ? 0x334455 : 0x000000);

      // Орбита строится по реальному радиусу — в «читаемом» режиме она сжата
      // тем же преобразованием, поэтому кольца остаются согласованы с шариками.
      var pos = orbits[b.key].geometry.attributes.position;
      var Rr = orbitScale(b.orbitAu);
      for (var i = 0; i <= 128; i++) {
        var a = (i / 128) * Math.PI * 2;
        pos.setXYZ(i, Math.cos(a) * Rr, 0, -Math.sin(a) * Rr);
      }
      pos.needsUpdate = true;
    });

    var d = camAngle.dist;
    camera.position.set(
      Math.cos(camAngle.az) * Math.cos(camAngle.el) * d,
      Math.sin(camAngle.el) * d,
      Math.sin(camAngle.az) * Math.cos(camAngle.el) * d
    );
    camera.lookAt(0, 0, 0);
    renderer.render(scene3, camera);
  }

  // ── Панели ──────────────────────────────────────────────────────────────────

  function selectBody(key) {
    state.selected = key;
    renderFacts();
    render3();
  }

  function renderFacts() {
    var f = bodyFacts(state.selected, state.when);
    if (!f) return;
    var b = f.body;
    setText('ssName', tr('p_' + b.key.toLowerCase()));

    var box = $('ssFacts');
    if (!box) return;
    var rows = [];
    rows.push(kv(tr('from_sun'), fmt(f.fromSunAu, 3) + ' ' + tr('u_au') + ' · ' + fmt(f.fromSunAu * AU_KM / 1e6, 1) + ' ' + tr('u_mkm')));
    if (b.key !== 'Earth') {
      rows.push(kv(tr('from_earth_now'), fmt(f.fromEarthAu, 3) + ' ' + tr('u_au') + ' · ' + fmt(f.fromEarthAu * AU_KM / 1e6, 1) + ' ' + tr('u_mkm')));
      rows.push(kv(tr('light_delay'), fmt(f.lightMin, 1) + ' ' + tr('u_min')));
      // «Сколько лететь» — по скорости аппарата, а не по свету: людям нужно это.
      var kmToGo = f.fromEarthAu * AU_KM;
      rows.push(kv(tr('travel_probe'), humanDuration(kmToGo / C.probeKmS / 3600)));
      if (f.magnitude != null) rows.push(kv(tr('magnitude'), fmt(f.magnitude, 1) + (f.magnitude < 6 ? ' · ' + tr('naked_eye') : '')));
      if (f.elongation != null) rows.push(kv(tr('elongation'), fmt(f.elongation, 0) + '°'));
    }
    rows.push(kv(tr('your_weight'), fmt(C.weightKg * b.gravity, 1) + ' ' + tr('u_kg')));
    rows.push(kv(tr('day_length'), humanDuration(b.dayH)));
    rows.push(kv(tr('year_length'), fmt(b.yearD, b.yearD < 100 ? 1 : 0) + ' ' + tr('u_days_earth')));
    rows.push(kv(tr('radius'), fmt(b.radiusKm, 0) + ' ' + tr('u_km')));
    rows.push(kv(tr('moons'), b.moons === 0 ? tr('no_moons') : fmt(b.moons, 0)));
    box.innerHTML = rows.join('');
  }

  function kv(k, v) { return '<div class="ss-kv"><span>' + esc(k) + '</span><b>' + esc(v) + '</b></div>'; }

  function renderParade() {
    var box = $('ssParade');
    if (!box) return;
    var now = paradeSpread(state.when);
    setText('ssSpreadNow', fmt(now, 0) + '°');
    var list = findParades(new Date(), 4);
    if (!list.length) { box.innerHTML = '<p class="ss-none">' + esc(tr('no_parade')) + '</p>'; return; }
    box.innerHTML = list.map(function (p) {
      return '<div class="ss-row"><span class="ss-row-n">' + esc(fmtDate(p.date)) + '</span>' +
        '<span class="ss-row-d">' + esc(tr('spread') + ' ' + fmt(p.spread, 0) + '°') + '</span></div>';
    }).join('');
  }

  function renderWhen() {
    setText('ssWhen', fmtDate(state.when));
    var b = $('ssLive');
    if (b) { b.classList.toggle('on', state.live); b.setAttribute('aria-pressed', state.live ? 'true' : 'false'); }
  }

  /* Ответ выдан — планеты расставлены и парад посчитан. Отдельно помечаем,
     поднялась ли 3D-сцена: если у заметной доли людей тул «работает» без неё,
     это другой продукт, и знать об этом надо из данных, а не из догадок. */
  var answered = false;
  function markAnswered() {
    if (answered) return;
    answered = true;
    // ⚠️ ОТЛОЖЕННО, и это не мелочь: первая отрисовка случается ВНУТРИ boot(),
    // до stage('ready'), поэтому прямой вызов давал порядок
    // load -> complete -> ready. Воронка, где ответ выдан раньше готовности,
    // не просто выглядит странно — в ней бессмысленны все задержки dwell_ms.
    setTimeout(function () { stage('complete'); }, 0);
    ae('tool_complete', { slug: 'solar-system', scene: sceneReady ? '3d' : 'flat', scale: state.scale });
  }

  function renderAll() {
    renderWhen();
    renderFacts();
    renderParade();
    render3();
    markAnswered();
  }

  // ── Управление ──────────────────────────────────────────────────────────────

  // fromUser=true only for a real click — boot() restores through here too.
  // Without the split the default was filed as a choice on every load:
  // `scale_readable` 495 events / 322 sessions in 30 days. Same class as
  // moon.js and video-filter.
  function setScale(v, fromUser) {
    state.scale = v;
    var a = $('ssScaleReadable'), b = $('ssScaleTrue');
    if (a) a.classList.toggle('on', v === 'readable');
    if (b) b.classList.toggle('on', v === 'true');
    var note = $('ssScaleNote');
    if (note) note.textContent = v === 'true' ? tr('scale_true_note') : tr('scale_readable_note');
    if (window.__toolSettings) window.__toolSettings.save('solar-system', 'scale', v);
    render3();
    ae('feature_use', { slug: 'solar-system', feature: (fromUser ? 'scale_' : 'scale_restored_') + v });
  }

  function shiftDays(n) {
    state.live = false; state.speedDays = 0;
    state.when = new Date(state.when.getTime() + n * 86400000);
    renderAll();
  }

  function boot() {
    stage('load');
    var on = function (id, fn) { var el = $(id); if (el) el.addEventListener('click', fn); };
    on('ssPrev', function () { shiftDays(-30); });
    on('ssNext', function () { shiftDays(30); });
    on('ssLive', function () { state.live = true; state.speedDays = 0; state.when = new Date(); renderAll(); });
    on('ssScaleReadable', function () { setScale('readable', true); });
    on('ssScaleTrue', function () { setScale('true', true); });
    on('ssPlay', function () {
      state.speedDays = state.speedDays ? 0 : 3;
      state.live = false;
      var el = $('ssPlay'); if (el) el.classList.toggle('on', !!state.speedDays);
      ae('feature_use', { slug: 'solar-system', feature: 'play' });
    });

    // Кнопки выбора планеты — дублируют клик по сцене, но работают и без WebGL,
    // и с клавиатуры. 3D-только-мышью отрезал бы часть людей от данных.
    var picker = $('ssPicker');
    if (picker) {
      BODIES.forEach(function (b) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ss-pick';
        btn.textContent = tr('p_' + b.key.toLowerCase());
        btn.addEventListener('click', function () {
          selectBody(b.key);
          picker.querySelectorAll('.ss-pick').forEach(function (x) { x.classList.remove('on'); });
          btn.classList.add('on');
        });
        if (b.key === state.selected) btn.classList.add('on');
        picker.appendChild(btn);
      });
    }

    if (window.__toolSettings) {
      var sc = window.__toolSettings.load('solar-system', 'scale', 'readable');
      if (sc === 'true' || sc === 'readable') state.scale = sc;
    }
    setScale(state.scale, false);

    initThree().then(function (ok) {
      if (!ok) {
        var host = sceneHost();
        if (host) host.innerHTML = '<div class="ss-err">' + tr('no_webgl') + '</div>';
        ae('tool_diagnostic', { slug: 'solar-system', issue: 'no_webgl' });
      }
      renderAll();
      if (sceneReady) requestAnimationFrame(function () { onResize(); });
      stage('ready');
    });

    // Проигрывание. Не rAF — незачем жечь батарею ради движения планет.
    setInterval(function () {
      if (state.speedDays) { state.when = new Date(state.when.getTime() + state.speedDays * 86400000); renderAll(); }
      else if (state.live) { state.when = new Date(); render3(); }
    }, 120);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
}());
